import { useEffect, useState } from "react";
import { gql, useQuery } from "@apollo/client";

const CURRENT_USER = gql`
  query CurrentUser {
    viewer {
      id
      name
      email
      phone
    }
  }
`;

const filterAppleEmail = email => {
  if (email?.match?.(/@privaterelay\.appleid\.com/)) {
    return null;
  }

  return email;
};

export const useCurrentUser = () => {
  const [user, setUser] = useState();
  const { data, error, loading } = useQuery(CURRENT_USER);

  useEffect(() => {
    if (!loading) {
      setUser({
        ...data?.viewer,
        email: filterAppleEmail(data?.viewer?.email ?? null)
      });
    }
  }, [error, loading, data]);

  return user;
};
